module.exports = __webpack_public_path__ + "fonts/RobotoMono-BoldItalic.33a87c67.woff";